module.exports = {
  HUME_JOBS_URL: 'https://jobs.polymer.co/hume-ai',
  HUME_DEV_URL: 'https://dev.hume.ai',
  HUME_PRICING_URL: 'https://beta.hume.ai/pricing',
  HUME_TERMS_OF_USE: 'https://beta.hume.ai/policies/terms-of-use',
};
